var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.109 108.673V120.693H62.5228C63.2068 112.782 65.7595 107.216 74.5873 99.389L112.109 67.3788V95.4683H125.616V43.79H48.8127V69.5498H62.3196V57.297H103.123L65.7843 89.1634L65.695 89.2476C50.0468 103.102 48.8027 114.284 48.8027 127.459V134.21H125.621V108.683H112.114L112.109 108.673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeta);
export default __webpack_public_path__ + "static/media/ZETA.d394a5cb1052e73b39517b60883c3e7e.svg";
export { ForwardRef as ReactComponent };